<ng-container *ngIf="router.url.includes('eventterms')">
    <!-- <app-top-header></app-top-header> -->
    <app-header></app-header>
</ng-container>
<div class="app-event-terms">
    <div class=" pt-100"
        [ngClass]="{'pt-0':router.url.includes('pay_per_view'),'pt-15' : !router.url.includes('eventterms')}">
        <div class="container" fxLayout="column">
            <h1 class="text-center ff " *ngIf="router.url.includes('eventterms')">Terms and Conditions</h1>
            <div mat-dialog-content fxLayout="column">
                <div fxFlex="100%" fxFlex.xs="100%" class="mb-20" [ngClass]="{'p-4':router.url.includes('eventterms')}">
                    <div [ngClass]="{'terms-box':!router.url.includes('eventterms')}">
                        <ng-container *ngIf="streamInfo?.t_and_c !=null && streamInfo.t_and_c !=''">
                            <div [innerHTML]="streamInfo.t_and_c | safe: 'html'" class="ck-editor">
                            </div>
                        </ng-container>
                        <ng-container *ngIf="(streamInfo?.t_and_c == null || streamInfo.t_and_c =='') || router.url.includes('eventterms')">
                            <p>By participating in this Livestream event, I agree to be bound by the following terms and
                                conditions:
                            </p>
                            <ul class="pl-30 mb-40">
                                <li>I agree not to record (directly or indirectly), download, modify, copy, reproduce,
                                    republish,
                                    upload, post, transmit, or distribute in any way this event in whole or in part.
                                </li>
                                <li>I understand that any copying including recording of the event is unauthorized and
                                    constitutes a
                                    violation of US, UK & International Copyright Law.</li>
                                <li>I understand that failure to abide by these terms and conditions may result in the
                                    loss
                                    of
                                    access to future event broadcasts on <span class="text-capitalize">{{clientDetails.slug}}</span>.</li>
                                <li>If others will be participating in the viewing of the event with me as a group, I
                                    will
                                    ensure
                                    that they have read and agreed to the conditions of this agreement.</li>
                                <li>I agree and understand that my email ID and password are solely for my use and are
                                    not
                                    to be
                                    shared with anyone.</li>
                                <li>I understand that <span class="text-capitalize">{{clientDetails.slug}}</span> is not responsible for any technical difficulties or
                                    problems
                                    that may
                                    be incurred in the receipt of the live broadcast.</li>
                                <li>If I am encountering issues with accessing the stream or any other technical
                                    problems, I
                                    can use
                                    the link provided for "Contact Us". Comments made in page post threads, Twitter
                                    feeds,
                                    Instagram
                                    posts etc. will not be addressed by the support staff.</li>
                                <li>I understand that I am to ensure that my web browser is up-to-date, and that I am to
                                    have a
                                    strong internet connection in order to experience a high-quality livestream.</li>
                                <li>I understand and agree that the live streaming is provided without warranties of any
                                    kind and
                                    that, to the fullest extent permissible under applicable law <span class="text-capitalize">{{clientDetails.slug}}</span> disclaims any
                                    and
                                    all such
                                    warranties, expressed or implied.</li>
                                <li>I agree and understand that the content I am viewing is the responsibility of the
                                    creator and
                                    not <span class="text-capitalize">{{clientDetails.slug}}</span> </li>
                                <li>I agree to abide by any and all chatroom guidelines, I understand that I may be
                                    ejected
                                    at any
                                    point for breaching these guidelines </li>
                                <li>By purchasing this ticket I have opted in to your mailing list, where I can
                                    unsubscribe
                                    at any
                                    time.</li>
                            </ul>
                        </ng-container>
                    </div>
                </div>
                <!-- <div fxFlex="100%" fxFlex.xs="100%" class="mt-5 mb-20 text-center"
                    *ngIf="!router.url.includes('eventterms')"> -->
                    <!-- <button mat-flat-button class="square-btn" (click)="submitSign()">
                        Submit
                    </button> -->
                    <!-- <button mat-flat-button class="flat-secondary-dialog-button ml-10" (click)="close()">
                        Close
                    </button>
                </div> -->
            </div>
        </div>

    </div>
</div>
<ng-container *ngIf="router.url.includes('eventterms')">
    <app-footer></app-footer>
</ng-container>